import React from 'react';
import Link from 'gatsby-link';
import facebookIcon from '../../images/facebook-circle.svg';

const Footer = () =>
  (<footer className="footer">
    <div className="container--wide">
      <div className="footer__info">
        <div className="footer__company">
          ETL Filter, Raitz & Kollegen <br/> Steuerberatungsgesellschaft
        </div>
        <div className="footer__address">
          Elisabeth-Selbert-Allee 9 <br/>
          63225 Langen
        </div>
        <div className="footer__contact">
          <span className="footer__icon">
            <i className="c-icon c-icon--phone"></i>
            <a href="tel:0049610390120">06103/90120</a>
          </span>
          <span className="footer__icon">
            <i className="c-icon c-icon--email"></i>
            <a href="mailto:kanzlei@frk-steuerberater.de">kanzlei@frk-steuerberater.de</a>
          </span>
          <span className="footer__icon">
            <a href="https://www.facebook.com/ETL-Filter-Raitz-Kollegen-Steuerberatungsgesellschaft-102290932554941" target="_blank" className="d-block">
              <img src={facebookIcon} className="footer__fb-icon mr-2"/>
              Facebook
            </a>
          </span>
        </div>
      </div>
      <div className="footer__bottom">
        <div className="footer__copyright">&copy; ETL Filter, Raitz & Kollegen 2021</div>
        <div className="footer__navigation">
          <nav>
            <ul>
              <li><Link to="/impressum/">Impressum</Link></li>
              <li><Link to="/datenschutz/">Datenschutz</Link></li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </footer>);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js